var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"why_list"},[_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" No setup fee")]),_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" Apply plugin code free of charge")]),_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" Customer service 24/7")]),_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" Cancel any time")])])
}]

export { render, staticRenderFns }